import ModalComponent from '@components/modal/Modal.component';
import NewTableComponent from '@components/table/NewTable.component';
import { Stack } from '@mui/material';
import COLUMN_TYPES from '@utils/table/columnTypes.table';
import { useTranslation } from 'react-i18next';
import { EngagedSupplierData } from '../audit-detail/tabs/AuditsOfferFormalization.tab';

interface EngagedPartnerModalProps {
  handleCloseModal: () => void;
  data: EngagedSupplierData[];
}

const EngagedPartnerModal = (props: EngagedPartnerModalProps) => {
  const { data, handleCloseModal } = props;
  const { t } = useTranslation();

  return (
    <ModalComponent
      aria-label="over-drawer"
      title={t('audits.OfferFormalization.engagedPartner.title', { supplierNbr: data.length })}
      handleClose={handleCloseModal}
      customColor='#FFFFFF'
      contentHeight='45dvh'
      contentFullWidth
      maxWidth='lg'
      content={(
        <Stack width="100%" height={'100%'} bgcolor='#F4F6F8' justifyContent='center' mt={'32px'} alignItems='center' spacing={5}>
          <NewTableComponent
            columns={[
              COLUMN_TYPES.TEXT({
                field: 'supplierUnitName',
                width: 300,
                label: t('audits.OfferFormalization.engagedPartner.supplier'),
              }),
              COLUMN_TYPES.TEXT({
                field: 'phone',
                label: t('audits.OfferFormalization.engagedPartner.phone'),
                sortable: true,
                width: 150,
              }),
              COLUMN_TYPES.TEXT({
                field: 'email',
                width: 150,
                label: t('audits.OfferFormalization.engagedPartner.mail'),
              }),
              COLUMN_TYPES.TEXT({
                field: 'city',
                width: 150,
                label: t('audits.OfferFormalization.engagedPartner.city'),
              }),
              COLUMN_TYPES.TEXT({
                field: 'country',
                width: 150,
                label: t('audits.OfferFormalization.engagedPartner.country'),
              }),
              COLUMN_TYPES.TEXT({
                field: 'auditOfferCount',
                label: t('audits.OfferFormalization.engagedPartner.supplierNbr'),
                sortable: true,
                width: 200,
              }),
            ]}
            disablePagination
            disableRowSelectionOnClick={true}
            disableEdition={true}
            disableRowSelection={true}
            fullScreen
            data={data || []}
          />
        </Stack>
      )}
    />
  );
};

export default EngagedPartnerModal;